<script setup lang="ts">
  import { SelectionBar } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { computed } from 'vue';
  import { dataTableSelectionContainerClass } from './DataTableSelection.css';

  const { t } = useLocale('table');

  const props = defineProps<{
    itemsSelected: number;
    maxItemsSelectable?: number;
    entityName?: string;
  }>();

  const maxReached = computed(() => {
    if (
      props.maxItemsSelectable &&
      props.itemsSelected >= props.maxItemsSelectable
    ) {
      return true;
    }
    return false;
  });

  const entity = computed(() => props.entityName || t('table.items'));

  const selectionText = computed(() => {
    const summary = `${props.itemsSelected} ${entity.value} ${t(
      'table.selected_items',
    )}`;

    if (maxReached.value) {
      return `${summary} ${t('table.max_reached', {
        entityName: props.entityName,
      })}`;
    }

    if (props.maxItemsSelectable) {
      return `${summary} ${t('table.max_items_selectable', {
        entityName: entity.value,
        maxItemsSelectable: props.maxItemsSelectable.toString(),
      })}`;
    }

    return summary;
  });
</script>

<template>
  <div v-if="itemsSelected" :class="dataTableSelectionContainerClass">
    <SelectionBar :text="selectionText" floating>
      <template #text><slot name="text" /></template>
      <slot name="actions" />
    </SelectionBar>
  </div>
</template>
